import { render } from "./purchasereport.vue?vue&type=template&id=0884c9f4&scoped=true"
import script from "./purchasereport.vue?vue&type=script&lang=js"
export * from "./purchasereport.vue?vue&type=script&lang=js"

import "./purchasereport.vue?vue&type=style&index=0&id=0884c9f4&scoped=true&lang=css"
import "./purchasereport.vue?vue&type=style&index=1&id=0884c9f4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0884c9f4"]])

export default __exports__